import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function FulfillmentAPI(): BringozApi {
  return {
    base: `/fulfillment`,
    infiniteScroll: {
      address: `/fulfillment`,
      cmd: 'GET'
    },
    actions: {
      getFulfillment: {
        address: '{id}',
        cmd: 'GET',
        updateable: true
      },
      getSteps: {
        address: '{id}/step',
        cmd: 'GET',
        updateable: true
      },
      getRelations: {
        address: '{id}/step/queryRelations',
        cmd: 'POST',
        updateable: true
      },
      splitStep: {
        address: '{id}/step/{stepId}/splitByLegs',
        cmd: 'POST',
        updateable: true
      },
      getStepDispatchOption: {
        address: '{id}/step/{stepId}/options',
        cmd: 'GET',
        updateable: true
      },
      dispatchStep: {
        address: '{id}/step/{stepId}/dispatchOption',
        cmd: 'POST',
        updateable: true
      },
      getStepDispatchTimeRanges: {
        address: '{fulfillmentId}/step/{stepId}/options',
        cmd: 'POST',
        updateable: true
      },
      getFulfillmentsByPage: {
        address: 'page',
        cmd: 'POST',
        updateable: true
      },
      getTotals: {
        address: 'totals',
        cmd: 'POST',
        updateable: true
      },
      bulkDispatch: {
        address: 'bulk/dispatch',
        cmd: 'POST',
        updateable: true
      },
      getFulfillmentStepsPrice: {
        address: '{fulfillmentId}/step/priceInfo',
        cmd: 'GET',
        updateable: true
      },
      updateFulfillmentStepsPriceFactor: {
        address: '{fulfillmentId}/step/priceFactor',
        cmd: 'POST',
        updateable: true
      },
      exportFulfillmentSteps: {
        address: 'export/steps',
        cmd: 'POST',
        updateable: true
      },
      getFulfillmentStepDefaultBranches: {
        address: '{fulfillmentId}/step/{stepId}/branches',
        cmd: 'GET',
        updateable: true
      },
      manuallyComplete: {
        address: '{id}/manuallyComplete',
        cmd: 'POST',
        updateable: true
      },
      splitStepPackages: {
        address: '{fulfillmentId}/step/{stepId}/moveStepItems',
        cmd: 'POST',
        updateable: true
      },
      getStepAttemptInfo: {
        address: '{fulfillmentId}/step/{stepId}/attemptInfo',
        cmd: 'GET',
        updateable: true
      },
      cancelStep: {
        address: '{fulfillmentId}/step/{stepId}/cancel',
        cmd: 'POST',
        updateable: true
      },
      forceCompleteLine: {
        address: '{fulfillmentId}/step/cancelSteps',
        cmd: 'POST',
        updateable: true
      },
      restoreFulfillments: {
        address: '{fulfillmentId}/duplicate',
        cmd: 'PUT',
        updateable: false
      },
      bulkRestoreFulfillments: {
        address: 'bulk/duplicate',
        cmd: 'PUT',
        updateable: false
      },
    }
  }
}

angular
  .module('bringoz.admin.fulfillment')
  .factory('FulfillmentAPI', FulfillmentAPI);
